// src/events/error/errorEventBus.ts

export type UiEventMap = {
  // Toast 消息
  'ui:toast': {
    type: 'success' | 'error' | 'info';
    message?: string;
    code?: string;
    level?: 'info' | 'warning' | 'error';
    messageKey?: string;
    context?: Record<string, unknown>;
  };

  // 错误弹窗（用于需要更强提示的错误场景）
  'ui:dialog': {
    type: 'stock-limit';
    code?: string;
    level?: 'info' | 'warning' | 'error';
    messageKey?: string;
    context?: Record<string, unknown>;
    maxQty: number;
    requestedQty?: number;
  };
};

type UiEventKey = keyof UiEventMap;

/**
 * 派发购物车相关的自定义事件，供全局监听使用。
 * @param type 事件类型
 * @param detail 事件负载
 */
export function emitUiEvent<K extends UiEventKey>(type: K, detail: UiEventMap[K]) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(type, { detail }));
}

/**
 * 监听购物车事件，并返回取消监听的函数。
 * @param type 事件类型
 * @param handler 响应回调
 * @returns 用于移除监听的函数
 */
export function onUiEvent<K extends UiEventKey>(
  type: K,
  handler: (detail: UiEventMap[K]) => void
): () => void {
  if (typeof window === 'undefined') return () => { };
  const listener = (e: Event) => {
    handler((e as CustomEvent<UiEventMap[K]>).detail);
  };
  window.addEventListener(type, listener);
  return () => window.removeEventListener(type, listener);
}

// 用于：显示 Toast
export const emitToast = (payload: UiEventMap['ui:toast']) =>
  emitUiEvent('ui:toast', payload);

// 用于：显示错误弹窗
export const emitDialog = (payload: UiEventMap['ui:dialog']) =>
  emitUiEvent('ui:dialog', payload);
